import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api'
import { adapterOrganization, adapterOrganizationSingle, getCoordinateObject } from '../../utils'
import { fetchOrganization } from '../organization/slice'
import singleAdapter from '../organization/adapter'
import adapter from './adapter'
import organizationService from './service'
// import dummyData from '../../database/organizations.json'
import * as config from "./config";
import { generateCoreExtraReducers, generateSliceCore } from '../core/tools'
import apiService from '../api/service'
const { NAME } = config;

const core = generateSliceCore(config);
const app = {
  initialState: {
    _payload: null,
    status: "idle",
    error: "",
    data: [],
    data_options: [],
    data_map: [],
    data_map_nested: [],
    data_statistic: {},

    details_status: 'idle',
    details_error: '',
    details_data: {},
    page_organization_detail_data: {},
    form_create_program_data: {},
  },
  action: {
    fetchOrganizations: createAsyncThunk(`${NAME}/fetchOrganizations`, async (options) => {
      const data = await apiService.get(NAME, options);
      return data;
    }),
    fetchOrganizationsStatistic: createAsyncThunk(`${NAME}/fetchOrganizationsStatistic`, async (options) => {
      const data = await apiService.getStatistic(NAME, options);
      return data;
    }),
    updateOrganization: createAsyncThunk(`${NAME}/updateOrganization`, async (options) => {
      const organization = await organizationService.updateDetails(options)
      return organization
    }),
    updateOrganizationDirect: createAsyncThunk(`${NAME}/updateOrganizationDirect`, async (options) => {
      const organization = await organizationService.updateDetailsDirect(options)
      return organization
    }),
    updateOrganizationLocation: createAsyncThunk(`${NAME}/updateOrganizationLocation`, async (options) => {
      const organization = await organizationService.updateOrganizationLocation(options)
      return organization
    }),
    addMember: createAsyncThunk(`${NAME}/addMember`, async (options) => {
      const response = await organizationService.addMember(options)
      return response
    }),
    deleteMilestone: createAsyncThunk(`${NAME}/deleteMilestone`, async (options) => {

      // remove milestone by id
      // const newOptions = {
      //   ...options,
      //   data: {
      //     ...options.data,
      //     milestones: options.data.milestones.filter(m => m.id !== options.milestoneId)
      //   }
      // }

      const organization = await organizationService.deleteMilestone(options.milestoneId)
      return organization
    }),
  },
};

/** Action - Thunks */
export const { setQuery, setCurrentPage, setSorter } = core.action;
export const { fetchOrganizations, fetchOrganizationsStatistic, updateOrganization, updateOrganizationDirect, updateOrganizationLocation, addMember, deleteMilestone } = app.action;

/** Reducer - Extra Reducers */
const coreExtraReducers = generateCoreExtraReducers(core.action);

export const organizationsSlice = createSlice({
  name: NAME,
  initialState: {
    ...core.initialState,
    ...app.initialState
  },
  reducers: {
    setStatus(state, action){
      state.status = action.payload
    },
    setPageItems(state, action){
      state.pageItems = action.payload
    }
  },
  extraReducers: {
    ...coreExtraReducers,

    [fetchOrganizations.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchOrganizations.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state._payload = action.payload
      state._total = action.payload.count
      const { results } = action.payload
      const organizations = matchOrganizations(results)
      state.data = organizations
      state.data_options = adapter.responseBodyToOptions(results)

      const withLocationOnly = results.filter(org => org.lokasiOrganisasi && org.lokasiOrganisasi.length > 0)
      const withValidLocationOnly = withLocationOnly.map(org => {
        const cloned = {...org}
        let newLocations = []

        const locations = org.lokasiOrganisasi

        if(locations && locations.length > 0){
          for (let index = 0; index < locations.length; index++) {
            const lokasi = locations[index];
            const coordinateString = lokasi.pinLocation
            const coordinateObject = getCoordinateObject(coordinateString)
            if(coordinateObject){
              newLocations.push(lokasi)
            }
          }
        }

        cloned.lokasiOrganisasi = newLocations
        return cloned
      })

      const dataByProvince = adapter.responseBodyToByProvince(withValidLocationOnly)
      state.data_by_province = dataByProvince
      const dataByCity = adapter.byProvinceToByCity(dataByProvince)
      state.data_by_city = dataByCity
      state.data_map = adapter.responseBodyToMap(dataByCity)
      state.data_map_nested = adapter.responseBodyToMapNested(dataByCity)

      // pagination
      // state.pageItems = organizations.slice(0, initialState.itemsPerPage)

      // temp: API bug handler
      if(action.payload.length > action.payload.count){
        state.totalItems = action.payload.length
      } else {
        state.totalItems = action.payload.count
      }
    },
    [fetchOrganizations.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    },
    [fetchOrganizationsStatistic.fulfilled]: (state, action) => {
      const { payload } = action
      state.data_statistic = adapter.responseBodyToStatistic(payload)
    },

    [fetchOrganization.pending]: (state) => {
      state.details_status = 'loading'
    },
    [fetchOrganization.fulfilled]: (state, action) => {
      state.details_status = 'succeeded'
      // const organization = matchOrganization(action.payload)

      // adapterOrganization: from account object to organization object
      const organization = api.organizations_available ? adapterOrganization({organisasi: [action.payload]}) : action.payload
      state.details_data = organization
      state.page_organization_detail_data = singleAdapter.responseBodyToRender(action.payload)
      state.form_create_program_data = singleAdapter.responseBodyToProgramForm(action.payload)
    },
    [fetchOrganization.rejected]: (state, action) => {
      state.details_status = 'failed'
      state.details_error = action.error.message
    },
  }
})

function matchOrganizations(payload){
  let result = []

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      result.push(matchOrganization(payload[index]))
    }
  }

  return result
}

function matchOrganization(payload){
  let result = {}
  if(payload){
    if(!payload.id){
      const o = payload
      result = adapterOrganizationSingle(o)
    } else {
      result = payload
    }
  }
  return result
}

export const {
  setStatus,
  setPageItems
} = organizationsSlice.actions

export const organizationsActions = {
  ...organizationsSlice.actions,
  ...core.action,
  ...app.action,
};

export default organizationsSlice.reducer
